import { Data, Logic } from "@cirrus/fe-lib"
import { pipe } from "fp-ts/es6/function"
import { assoc, identity, ifElse, prop, propEq, T, when } from "ramda"

export const whenLegacy = (legacyStyle, style = null) =>
  ifElse(propEq("variant", "legacy"), Data.asFunction(legacyStyle), Data.asFunction(style))

export const withFontSize = (typography) =>
  Logic.condition(
    [propEq("size", "medium"), assoc("fontSize", typography.pxToRem(15))],
    [propEq("size", "small"), assoc("fontSize", typography.pxToRem(12))],
    [T, identity],
  )

export const withHeight = (typography) => (props) =>
  pipe(
    props,

    Logic.condition(
      [propEq("size", "medium"), assoc("height", typography.pxToRem(44))],
      [propEq("size", "small"), assoc("height", typography.pxToRem(38))],
      [T, identity],
    ),

    when(prop("multipleValues"), Data.withRenamed("height", "rootHeight")),
  )
